import { Bar, Eyebrow, Quote } from './atoms'
import { useLang, t } from '../lib/lang'
import type { IdentitaBlock } from '../lib/types'

function Block({ eyebrow, body }: { eyebrow: string; body: string }) {
  return (
    <div style={{ display: 'flex', gap: 16 }}>
      <Bar />
      <div>
        <div style={{
          fontFamily: 'var(--font-body)', fontSize: 11, fontWeight: 600,
          letterSpacing: '0.24em', textTransform: 'uppercase',
          color: 'var(--fg)', marginBottom: 12,
        }}>{eyebrow}</div>
        <p style={{
          fontFamily: 'var(--font-body)', fontSize: 15, lineHeight: 1.55,
          color: 'var(--fg-muted)', margin: 0, maxWidth: 320,
        }}>{body}</p>
      </div>
    </div>
  )
}

export function Identita({ blocks }: { blocks: IdentitaBlock[] }) {
  const { lang } = useLang()
  if (!blocks.length) return null
  return (
    <section id="progetto" className="ax-pad-section" style={{ background: 'var(--paper)', padding: '120px 48px' }}>
      <div style={{ maxWidth: 1280, margin: '0 auto' }}>
        <Eyebrow>{t(lang, 'section_progetto')}</Eyebrow>
        <div style={{ marginTop: 20, maxWidth: 840 }}>
          <Quote>
            {lang === 'it'
              ? "Ancreus nasce da un'amicizia di lungo corso e da un gesto semplice: tornare dentro canzoni che hanno lasciato un segno."
              : 'Ancreus was born from a long-running friendship and a simple gesture: to step back inside songs that left a mark.'}
          </Quote>
        </div>
        <div className="ax-grid-identita" style={{
          marginTop: 80,
          display: 'grid',
          gridTemplateColumns: `repeat(${Math.min(4, blocks.length)}, 1fr)`,
          gap: 40,
        }}>
          {blocks.map((b) => <Block key={b.id} eyebrow={b.label} body={b.body} />)}
        </div>
      </div>
    </section>
  )
}
